import Paragraph from '../../Typography/Paragraph';
import classNames from 'classnames';
import { MapPin, Edit2 } from 'react-feather';
import { todayDate } from '../../Fields/Experience/Form';
import { StarFull, GripDots } from '../../CustomIcon';
export var TypePill = function (_a) {
    var type = _a.type, className = _a.className;
    return (<div className={classNames('inline-flex self-start rounded-full px-2 py-1 text-sm text-white', type.color, className)}>
      {type.title}
    </div>);
};
var CardExperience = function (_a) {
    var experience = _a.experience, _b = _a.background, background = _b === void 0 ? true : _b, className = _a.className, onClick = _a.onClick, _c = _a.defaultHighlighted, defaultHighlighted = _c === void 0 ? false : _c, _d = _a.draggable, draggable = _d === void 0 ? false : _d;
    var handleClick = function () {
        onClick && onClick();
    };
    return (<div className={classNames(className, 'relative', background && ' rounded-lg bg-white p-4 shadow-xl')}>
      <div className="absolute top-0 right-0 m-4 flex items-center gap-4">
        <Edit2 className="cursor-pointer transition-opacity hover:opacity-60" size={20} onClick={handleClick}/>
        {draggable && (<GripDots className="cursor-drag transition-opacity hover:opacity-60" size={24}/>)}
      </div>

      {experience.highlighted && !defaultHighlighted && (<StarFull className="absolute top-0 right-8 m-4" size={20}/>)}
      <TypePill type={experience.type} className="mb-3"/>
      <Paragraph size="headline">
        {experience.start_year} -{' '}
        {experience.end_year === todayDate.value ? "Aujourd'hui" : experience.end_year}
      </Paragraph>
      <Paragraph className="font-semibold md:text-lg">{experience.company}</Paragraph>
      <Paragraph className="md:text-lg">{experience.position}</Paragraph>
      <div className="my-2 flex items-center gap-2">
        <MapPin size={20}/>
        <Paragraph>{experience.location}</Paragraph>
      </div>
      <Paragraph size="sm" className="text-secondary-01">
        {experience.description}
      </Paragraph>
    </div>);
};
export default CardExperience;
